// Loads the Google Maps JS API exactly once. The key is referrer-restricted in
// Google Cloud Console, so it may live in the browser. It is served from /api/bootstrap.
let promise = null;

export function loadGoogleMaps(key) {
  if (typeof window === "undefined") return Promise.reject(new Error("no-window"));
  if (window.google?.maps?.places) return Promise.resolve(window.google);
  if (promise) return promise;
  if (!key) return Promise.reject(new Error("no-key"));
  // Google calls this global on an invalid/misconfigured key. Surface it so the UI
  // can hide the map instead of showing Google's default error card.
  window.gm_authFailure = () => {
    window.__gmapsAuthFailed = true;
    window.dispatchEvent(new Event("gmaps-auth-failed"));
  };
  promise = new Promise((resolve, reject) => {
    const cb = "__fleurinelleGmapsReady";
    window[cb] = () => resolve(window.google);
    const s = document.createElement("script");
    s.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}` +
      `&libraries=places,marker&v=weekly&loading=async&callback=${cb}`;
    s.async = true;
    s.defer = true;
    s.onerror = () => {
      promise = null;
      reject(new Error("load-failed"));
    };
    document.head.appendChild(s);
  });
  return promise;
}

// Morocco geographic centre — a safe default when no city pin is known yet.
export const MOROCCO_CENTER = { lat: 31.7917, lng: -7.0926 };
